import { generateHistogramArray as generateHistogramArrayDiagram} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    type: string;
    variantPaneVariants: boolean;
    variant?: number;
    activity?: number,
    from?: number,
    to?: number,
    discovery_rule_id?: string
};

export const generateHistogramArray = ({
    type, variantPaneVariants, activity, variant, from, to, discovery_rule_id,
    eventEmitter,
}: Props) => {
    generateHistogramArrayDiagram(type, variantPaneVariants, variant, activity, from, to,discovery_rule_id);
};
